import React from 'react'

export const Dashboard = () => <h1>Welcome to our Dashboard</h1>

